<template>
  <div class="tidbits">
    <div class="title">
      <img src="../assets/image/tips3_title.jpg" />
    </div>
    <div class="topNav">
      <ul>
        <li class="title">生态大讲堂</li>
        <li
          @click="onClick(index)"
          :class="{on:data.clas}"
          v-for="(data,index) in listTitle"
          :key="index"
        >
          <span>{{data.title}}</span>
          <div class="dian">
            <div></div>
          </div>
          <i>{{data.time}}</i>
        </li>
        <li class="title" style="  background: #f39800;">生态拍摄</li>
      </ul>
    </div>
    <div class="botcon">
      <div :class="{on:listCon.clas}" class="auto" v-for="(listCon,index) in listCon" :key="index">
        <div v-if="listCon.dis">
          <a :href="listCon.href" target="_blank">
            <div class="leftImg">
              <div class="hov">
                <img :src="listCon.img1" />
              </div>
              <div class="hov">
                <img :src="listCon.img2" />
              </div>
            </div>
            <div class="autoImg">
              <div class="hov">
                <img :src="listCon.img3" />
              </div>
              <div>
                <span>{{listCon.fontT}}</span>
                <p>{{listCon.fontP}}</p>
              </div>
              <div class="hov">
                <img :src="listCon.img4" />
              </div>
              <div class="hov">
                <img :src="listCon.img5" />
              </div>
            </div>
            <div class="rightImg">
              <div class="hov">
                <img :src="listCon.img6" />
              </div>
              <div class="hov">
                <img :src="listCon.img7" />
              </div>
            </div>
          </a>
        </div>
        <!-- 外拍结构 -->
        <div v-else class="wp">
          <a :href="listCon.href" target="_blank">
            <div class="wp_leftCon">
              <div class="topImg hov">
                <img :src="listCon.img1" alt />
              </div>
              <div class="botImg">
                <div class="hov">
                  <img :src="listCon.img2" alt />
                </div>
                <div class="hov">
                  <img :src="listCon.img3" alt />
                </div>
              </div>
            </div>
            <div class="wp_rightCon">
              <div class="botImg">
                <div class="hov">
                  <img :src="listCon.img4" alt />
                </div>
                <div class="hov">
                  <img :src="listCon.img5" alt />
                </div>
              </div>
              <div class="topImg hov">
                <img :src="listCon.img6" alt />
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listTitle: [
        { title: "走进康保", time: "9月7日", clas: true },
        { title: "走进西安", time: "10月25日", clas: false },
        { title: "走进秦皇岛", time: "11月21", clas: false },
        { title: "康保", time: "遗鸥拍摄", clas: false },
        { title: "老铁山", time: "猛禽拍摄", clas: false },
        { title: "西乡", time: "朱鹮拍摄", clas: false }
      ],
      listCon: [
        {
          dis: true,
          href: "http://article.photofans.cn/article-54702-1.html",
          fontT: "观鸟中国行 走进遗鸥之乡康保",
          fontP:
            "2019年9月7日，由佳友在线和爱鸟国际共同发起的“观鸟中国行”系列活动，本站携手中国野生动物保护协会科学考察委员会来到了中国遗鸥之乡——康保县。爱鸟...",
          img1: require("../assets/image/tips3list1img1.jpg?2"),
          img2: require("../assets/image/tips3list1img2.jpg?2"),
          img3: require("../assets/image/tips3list1img3.jpg?2"),
          img4: require("../assets/image/tips3list1img4.jpg?1"),
          img5: require("../assets/image/tips3list1img5.jpg?1"),
          img6: require("../assets/image/tips3list1img6.jpg?1"),
          img7: require("../assets/image/tips3list1img7.jpg?1"),
          clas: true
        },
        {
          dis: true,
          href: "http://article.photofans.cn/article-54945-1.html",
          fontT: "2019观鸟中国行，西安站成功举办",
          fontP:
            "本次观鸟中国行，我们向内地进发，来到中国第一古都——西安。随着近年秦岭与渭水的环境治理改善，西安这座历史文化名城如今亦散发着生态的气息，成为数十...",
          img1: require("../assets/image/tips3list2img19120301.jpg"),
          img2: require("../assets/image/tips3list2img19120302.jpg?1"),
          img3: require("../assets/image/tips3list2img19120303.jpg"),
          img4: require("../assets/image/tips3list2img19120304.jpg?1"),
          img5: require("../assets/image/tips3list2img19120305.jpg"),
          img6: require("../assets/image/tips3list2img19120306.jpg"),
          img7: require("../assets/image/tips3list2img19120307.jpg?1"),
          clas: false
        },
        {
          dis: true,
          href: "http://article.photofans.cn/article-55102-1.html",
          fontT: "2019观鸟中国行 秦皇岛站成功举办",
          fontP:
            "此次观鸟中国行，我们来到了位于山海之间的中国观鸟之都——秦皇岛。独特的地貌、丰富的植被、温润的气候，让这里成为了候鸟南北迁徙的重要通道和驿站，境...",
          img1: require("../assets/image/tips3list3img19120301.jpg"),
          img2: require("../assets/image/tips3list3img19120302.jpg"),
          img3: require("../assets/image/tips3list3img19122401.jpg?1"),
          img4: require("../assets/image/tips3list3img19120304.jpg"),
          img5: require("../assets/image/tips3list3img19120305.jpg"),
          img6: require("../assets/image/tips3list3img19120306.jpg"),
          img7: require("../assets/image/tips3list3img19120307.jpg"),
          clas: false
        },
        {
          dis: false,
          href: "http://article.photofans.cn/article-54702-1.html",
          img1: require("../assets/image/tips3list4img19120301.jpg"),
          img2: require("../assets/image/tips3list4img19120302.jpg?1"),
          img3: require("../assets/image/tips3list4img19120303.jpg"),
          img4: require("../assets/image/tips3list4img19120304.jpg"),
          img5: require("../assets/image/tips3list4img19120305.jpg?1"),
          img6: require("../assets/image/tips3list4img19120306.jpg"),
          clas: false
        },
        {
          dis: false,
          href: "http://article.photofans.cn/article-54781-1.html",
          img1: require("../assets/image/tips3list5img19120303.jpg"),
          img2: require("../assets/image/tips3list5img19120301.jpg"),
          img3: require("../assets/image/tips3list5img19120302.jpg"),
          img4: require("../assets/image/tips3list5img19120304.jpg"),
          img5: require("../assets/image/tips3list5img19120305.jpg"),
          img6: require("../assets/image/tips3list5img19120306.jpg"),
          clas: false
        },
        {
          dis: false,
          href: "http://article.photofans.cn/article-54945-1.html",
          img1: require("../assets/image/tips3list6img19120301.jpg"),
          img2: require("../assets/image/tips3list6img19120302.jpg"),
          img3: require("../assets/image/tips3list6img19120303.jpg"),
          img4: require("../assets/image/tips3list6img19120304.jpg"),
          img5: require("../assets/image/tips3list6img19120305.jpg"),
          img6: require("../assets/image/tips3list6img19120306.jpg?1"),
          clas: false
        }
      ]
    };
  },
  methods: {
    onClick(index) {
      for (let key in this.listTitle) {
        this.listTitle[key].clas = false;
        this.listCon[key].clas = false;
      }
      this.listTitle[index].clas = true;
      this.listCon[index].clas = true;
    }
  }
};
</script>
<style scoped>
.botcon .auto .wp {
  float: left;
  width: 100%;
  height: 100%;
}
.botcon .auto .wp .hov:hover img {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}
.botcon .auto .wp img {
  float: left;
  width: 100%;
  height: 100%;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -ms-transition: all 0.5s;
  -o-transition: all 0.5s;
}
.botcon .auto .wp a {
  float: left;
  width: 100%;
  height: 100%;
}
.botcon .auto .wp .wp_leftCon {
  float: left;
  position: relative;
  width: 597px;
  height: 100%;
}
.botcon .auto .wp .wp_leftCon .topImg {
  float: left;
  width: 100%;
  height: 343px;
}
.botcon .auto .wp .wp_leftCon .botImg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 340px;
}
.botcon .auto .wp .wp_leftCon .botImg div {
  float: left;
  width: 296px;
  height: 340px;
}
.botcon .auto .wp .wp_leftCon .botImg div:nth-child(2) {
  position: absolute;
  right: 0;
  top: 0;
}
.botcon .auto .wp .wp_rightCon {
  float: right;
  position: relative;
  width: 597px;
  height: 100%;
}
.botcon .auto .wp .wp_rightCon .topImg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 340px;
}
.botcon .auto .wp .wp_rightCon .botImg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 343px;
}
.botcon .auto .wp .wp_rightCon .botImg div {
  float: left;
  width: 296px;
  height: 343px;
}
.botcon .auto .wp .wp_rightCon .botImg div:nth-child(2) {
  position: absolute;
  right: 0;
  top: 0;
}
.tidbits {
  float: left;
  width: 100%;
  height: 1084px;
  background: url(../assets/image/tips3_bj.jpg) no-repeat center;
}
.title {
  float: left;
  width: 100%;
  height: 215px;
  text-align: center;
}
.topNav {
  position: relative;
  float: left;
  min-width: 1200px;
  max-width: 1920px;
  width: 100%;
  height: 103px;
}
.topNav::after {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  bottom: 53px;
  width: 100%;
  height: 1px;
  background: #b3d465;
}
.topNav ul {
  position: relative;
  margin: 0 auto;
  width: 1200px;
  height: 100%;
}
.topNav ul li {
  position: relative;
  float: left;
  height: 100%;
  margin-right: 47px;
  cursor: pointer;
}
.topNav ul li:nth-child(4) {
  margin-right: 250px;
}

.topNav ul li:nth-child(7) {
  margin: 0;
}

.topNav ul li:last-child {
  position: absolute;
  top: 1px;
  left: 700px;
  z-index: 99;
}
.topNav ul li.title {
  padding: 0 15px;
  text-align: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-top: 9px;
  height: 40px;
  line-height: 40px;
  width: auto;
  margin-right: 40px;
  background: #85c023;
  color: #fff;
  font-size: 24px;
}
.topNav ul li.on span {
  margin-top: 0;
  color: #7faf41;
  font-size: 30px;
}
.topNav ul li span {
  margin-top: 10px;
  font-size: 24px;
}
.topNav ul li i {
  margin-top: 18px;
  font-size: 16px;
  color: #666;
}
.topNav ul li span,
.topNav ul li i {
  display: block;
  width: 100%;
  text-align: center;
}
.topNav ul li .dian {
  position: absolute;
  width: 10px;
  height: 10px;
  left: 50%;
  top: 44px;
  transform: translateX(-50%);
  background: #b3d465;
  border-radius: 50%;
}
.topNav ul li .dian div {
  float: left;
  background: #b3d465;
  border-radius: 50%;
}
.topNav ul li.on .dian div {
  animation: fd 0.6s infinite linear;
  -webkit-animation: fd 0.6s infinite linear;
  -moz-animation: fd 0.6s infinite linear;
  -ms-animation: fd 0.6s infinite linear;
  -o-animation: fd 0.6s infinite linear;
}
@keyframes fd {
  0% {
    width: 10px;
    height: 10px;
    transform: scale(1);
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    opacity: 0.4;
  }
  100% {
    width: 10px;
    height: 10px;
    transform: scale(1.6);
    -webkit-transform: scale(1.6);
    -moz-transform: scale(1.6);
    -ms-transform: scale(1.6);
    -o-transform: scale(1.6);
    opacity: 0.4;
    /* opacity: 0; */
  }
}
@-webkit-keyframes fd {
  0% {
    width: 10px;
    height: 10px;
    transform: scale(1);
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    opacity: 0.4;
  }
  100% {
    width: 10px;
    height: 10px;
    transform: scale(1.6);
    -webkit-transform: scale(1.6);
    -moz-transform: scale(1.6);
    -ms-transform: scale(1.6);
    -o-transform: scale(1.6);
    opacity: 0.4;
    /* opacity: 0; */
  }
}
@-o-keyframes fd {
  0% {
    width: 10px;
    height: 10px;
    transform: scale(1);
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    opacity: 0.4;
  }
  100% {
    width: 10px;
    height: 10px;
    transform: scale(1.6);
    -webkit-transform: scale(1.6);
    -moz-transform: scale(1.6);
    -ms-transform: scale(1.6);
    -o-transform: scale(1.6);
    opacity: 0.4;
    /* opacity: 0; */
  }
}
@-ms-keyframes fd {
  0% {
    width: 10px;
    height: 10px;
    transform: scale(1);
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    opacity: 0.4;
  }
  100% {
    width: 10px;
    height: 10px;
    transform: scale(1.6);
    -webkit-transform: scale(1.6);
    -moz-transform: scale(1.6);
    -ms-transform: scale(1.6);
    -o-transform: scale(1.6);
    opacity: 0.4;
    /* opacity: 0; */
  }
}
@-moz-keyframes fd {
  0% {
    width: 10px;
    height: 10px;
    transform: scale(1);
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    opacity: 0.4;
  }
  100% {
    width: 10px;
    height: 10px;
    transform: scale(1.6);
    -webkit-transform: scale(1.6);
    -moz-transform: scale(1.6);
    -ms-transform: scale(1.6);
    -o-transform: scale(1.6);
    opacity: 0.4;
    /* opacity: 0; */
  }
}
.botcon {
  float: left;
  position: relative;
  width: 100%;
  height: 687px;
}
.botcon .auto {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: none;
}
.botcon .auto.on {
  display: block;
}
.botcon .auto a {
  float: left;
  width: 100%;
}
.botcon .auto .leftImg {
  float: left;
  width: 296px;
  height: 100%;
}
.botcon .auto .leftImg div:nth-child(1) {
  float: left;
  width: 100%;
  height: 252px;
}
.botcon .auto div {
  overflow: hidden;
}
.botcon .auto div img {
  float: left;
  width: 100%;
  height: 100%;
  transition: all 0.4s;
}
.botcon .auto .leftImg div:nth-child(2) {
  float: left;
  margin-top: 7px;
  width: 100%;
  height: 427px;
}
.botcon .auto .autoImg {
  float: left;
  margin-left: 7px;
  width: 626px;
  height: 686px;
}
.botcon .auto .autoImg div:nth-child(1) {
  float: left;
  width: 100%;
  height: 338px;
}
.botcon .auto .autoImg div:nth-child(2) {
  float: left;
  padding: 20px 17px 20px 17px;
  width: 592px;
  height: 105px;
}
.botcon .auto .autoImg div:nth-child(2) span {
  float: left;
  color: #000;
  width: 592px;
  font-size: 27px;
  font-family: siyuan1;
}
.botcon .auto .autoImg div:nth-child(2) p {
  float: left;
  width: 100%;
  margin-top: 6px;
  font-size: 16px;
  color: #666;
  line-height: 30px;
  font-family: siyuan3;
}
.botcon .auto .autoImg div:nth-child(3) {
  float: left;
  width: 310px;
  height: 204px;
}
.botcon .auto .autoImg div:nth-child(4) {
  float: right;
  width: 310px;
  height: 204px;
}
.botcon .auto .rightImg {
  float: right;
  width: 263px;
  height: 686px;
}
.botcon .auto .rightImg div:nth-child(1) {
  float: left;
  width: 100%;
  height: 337px;
}
.botcon .auto .rightImg div:nth-child(2) {
  float: left;
  margin-top: 10px;
  width: 100%;
  height: 339px;
}
.botcon .auto .hov:hover img {
  transform: scale(1.05);
}
</style>